import { Button, Page } from '@rammetec/design-system'

export interface ForbiddenPageProps {
  onBack: () => void
}

export function ForbiddenPage({ onBack }: ForbiddenPageProps) {
  return (
    <Page
      name="vectorhub.module.forbidden"
      title="Acesso negado"
      description="Você não tem acesso a este recurso."
      actions={<Button onClick={onBack}>Voltar</Button>}
    />
  )
}
